import React, { useState, useEffect, useCallback } from 'react';
import Masonry from 'react-masonry-css';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Paper,
  Tabs,
  Tab,
  IconButton,
  TextField,
  InputAdornment,
  Avatar,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemAvatar,
  ListItemIcon,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  useTheme,
  useMediaQuery,
  Snackbar,
  Alert,
  Collapse,
  MobileStepper,
  FormControl,
  InputLabel,
  Select,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { 
  RefreshOutlined, 
  SearchOutlined,
  LaunchOutlined as LaunchIcon,
  ThumbUp as ThumbUpIcon,
  Comment as CommentIcon,
  Repeat as RepeatIcon,
  FilterList as FilterListIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Close as CloseIcon,
  Share as ShareIcon,
  MoreVert as MoreVertIcon,
  FormatQuote as FormatQuoteIcon,
  Analytics as AnalyticsIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  Pinterest as PinterestIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
  DateRange as DateRangeIcon,
  SortByAlpha as SortByAlphaIcon,
  FilterAlt as FilterAltIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
  AccountCircle as AccountCircleIcon,
  UploadFile as UploadFileIcon,
  Edit as EditIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  AccessTime as AccessTimeIcon,
  Image as ImageIcon,
  Videocam as VideocamIcon,
  ViewCarousel as ViewCarouselIcon,
  TextFields as TextFieldsIcon,
  CalendarToday as CalendarTodayIcon,
  People as PeopleIcon,
  TextSnippet as TextSnippetIcon,
  Refresh as RefreshIcon,
  Person as PersonIcon,
  Home as HomeIcon,
  BarChart as BarChartIcon,
  Search as SearchIcon,
  Info as InfoIcon,
  BookmarkBorder as BookmarkBorderIcon,
  Book as BookIcon,
  Article as ArticleIcon,
  VideoLibrary as VideoIcon,
  Description as DocumentIcon,
  Forum as ForumIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  ViewList as ViewListIcon,
  GridView as GridViewIcon,
  SvgIcon,
  CloudDownload as CloudDownloadIcon
} from '@mui/icons-material';
import AnimatedLogo from '../components/common/AnimatedLogo';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip as RechartsTooltip, 
  Legend,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis
} from 'recharts';
import { TagCloud } from 'react-tagcloud';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import FeatureLockOverlay from '../components/FeatureLockOverlay'; // Added
import { Helmet } from 'react-helmet-async';
import LoadingScreen from '../components/common/LoadingScreen'; // Added import

import PostCard from '../components/PostCard';
import './MasonryStyles.css'; // Make sure to create this file

const LinkedInMetrics = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tabValue, setTabValue] = useState(0);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState('');
  const [profileUrl, setProfileUrl] = useState('');
  const [userProfile, setUserProfile] = useState(null);
  const [totalPages, setTotalPages] = useState(1);

  // Add state for LinkedIn profile
  const [linkedinProfile, setLinkedinProfile] = useState('');

  // Add state for LinkedIn profile data
  const [linkedinProfileData, setLinkedinProfileData] = useState(null);

  // States for different metrics
  const [posts, setPosts] = useState([]);
  const [profileStats, setProfileStats] = useState(null);
  const [orgStats, setOrgStats] = useState(null);
  const [adsStats, setAdsStats] = useState(null);

  // Add state for modal
  const [selectedPost, setSelectedPost] = useState(null);

  // Add sorting and filtering states
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'neutral' // 'neutral', 'asc', or 'desc'
  });
  const [filters, setFilters] = useState({
    format: 'all', // 'all', 'Image', 'Video', 'Carousel', 'Text'
    dateRange: 'all',
    search: ''
  });

  // Add state for tabs
  const [activeTab, setActiveTab] = useState('posts'); // 'posts', 'analytics', or 'recommendations'

  // Add these state variables
  const [isFromCache, setIsFromCache] = useState(false);
  const [viewType, setViewType] = useState('table'); // 'table' or 'grid'

  // Add a new state for latest update time
  const [lastUpdateTime, setLastUpdateTime] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  // New state for subscription check
  const [subscriptionStatusLoading, setSubscriptionStatusLoading] = useState(true);
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(false); // True if Pro/Business, false if Free or error
  const [currentPlanId, setCurrentPlanId] = useState(null);

  // Plan IDs from environment variables
  const PRO_PLAN_ID = process.env.REACT_APP_PADDLE_PRO_MONTHLY;
  const PRO_YEARLY_ID = process.env.REACT_APP_PADDLE_PRO_YEARLY;
  const BUSINESS_PLAN_ID = process.env.REACT_APP_PADDLE_BUSINESS_MONTHLY;
  const BUSINESS_YEARLY_ID = process.env.REACT_APP_PADDLE_BUSINESS_YEARLY;

  console.log('[LinkedInMetrics] PRO_PLAN_ID:', PRO_PLAN_ID);
  console.log('[LinkedInMetrics] BUSINESS_PLAN_ID:', BUSINESS_PLAN_ID);

  useEffect(() => {
    const checkSubscription = async () => {
      setSubscriptionStatusLoading(true);
      try {
        const response = await api.get('/api/subscriptions/status');
        const subscription = response.data.subscription;
        
        if (subscription && subscription.status === 'active') {
          console.log('Subscription:', subscription);
          setCurrentPlanId(subscription.price_id);
          if (
            subscription.price_id === PRO_PLAN_ID || 
            subscription.price_id === PRO_YEARLY_ID || 
            subscription.price_id === BUSINESS_PLAN_ID || 
            subscription.price_id === BUSINESS_YEARLY_ID
          ) {
            setIsFeatureAllowed(true);
            console.log('[LinkedInMetrics] Feature IS ALLOWED.');
          } else {
            setIsFeatureAllowed(false); // Free plan
            console.log('[LinkedInMetrics] Feature NOT ALLOWED (Mismatched plan ID).');
          }
        } else {
          setIsFeatureAllowed(false); // No active subscription or other status
          console.log('[LinkedInMetrics] Feature NOT ALLOWED (No active sub or status not active).');
        }
      } catch (error) {
        console.error("[LinkedInMetrics] Error fetching subscription status:", error);
        setIsFeatureAllowed(false); // Error condition, treat as not allowed
      } finally {
        setSubscriptionStatusLoading(false);
      }
    };
    checkSubscription();
  }, [PRO_PLAN_ID, PRO_YEARLY_ID, BUSINESS_PLAN_ID, BUSINESS_YEARLY_ID]);

  // Add the missing handler functions
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleOpenCommentDialog = (post) => {
    // This function would handle opening a comment dialog
    // For now, just log the action
    console.log('Opening comments for post:', post.id);
  };

  const handleRemixClick = (post) => {
    // This function would handle remixing a post
    // For now, just log the action
    console.log('Remixing post:', post.id);
  };

  // Add auto-refresh functionality
  const autoRefreshPosts = useCallback(async () => {
    if (linkedinProfile) {
      const username = extractUsername(linkedinProfile);
      if (username) {
        console.log('Auto-refreshing posts...');
        await fetchPostsFromAPI(username);
      }
    }
  }, [linkedinProfile]);

  // Set up auto-refresh interval
  useEffect(() => {
    // Refresh every day (86400000 ms)
    const refreshInterval = setInterval(autoRefreshPosts, 86400000);

    // Cleanup interval on unmount
    return () => clearInterval(refreshInterval);
  }, [autoRefreshPosts]);

  // Add a function to handle refreshing data
  const handleRefreshData = async () => {
    try {
      setLoading(true);
      setError(null);
      setPosts([]);
      
      if (linkedinProfile) {
        const username = extractUsername(linkedinProfile);
        if (username) {
          await fetchPostsFromAPI(username); // Force refresh from API
        }
      }
    } catch (error) {
      console.error('Failed to refresh data:', error);
      setError('Failed to refresh data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Update useEffect to use bot data by default
  useEffect(() => {
    const fetchUserProfile = async () => {
      setInitialLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/auth/profile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        
        const userData = response.data.user;
        setUserProfile(userData);

        if (userData.linkedinProfile) {
            setLinkedinProfile(userData.linkedinProfile);
            await fetchLinkedInProfileData(userData.linkedinProfile);
            const username = extractUsername(userData.linkedinProfile);
            if (username) {
            await fetchPostsFromDatabase(username);
          }
        }
      } catch (err) {
        console.error('Error fetching user profile:', err);
        setError('Error fetching user profile: ' + err.message);
      } finally {
        setInitialLoading(false);
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  // Update fetchPostsFromDatabase function with better error handling
  const fetchPostsFromDatabase = async (username) => {
    try {
      setLoading(true);
      setError(null);
      setPosts([]);
      setIsFromCache(false);

      console.log('Fetching posts from database for username:', username);
      
      try {
        const response = await api.get('/api/linkedin/profile/posts', {
          params: { username }
        });
        
        if (response.data && Array.isArray(response.data)) {
          console.log('Found posts in database:', response.data.length);
          const formattedPosts = formatPosts(response.data);
          setPosts(formattedPosts);
        } else {
          console.log('No posts found in database, fetching from API...');
          await fetchPostsFromAPI(username);
        }
      } catch (error) {
        // If 404, it means no posts in database, so fetch from API
        if (error.response?.status === 404) {
          console.log('No posts found in database, fetching from API...');
          await fetchPostsFromAPI(username);
        } else {
          throw error;
        }
      }
    } catch (error) {
      console.error('Failed to fetch posts:', error);
      setError(
        error.response?.data?.message || 
        error.message || 
        'Failed to fetch posts. Please try again.'
      );
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  // Update fetchLinkedInProfileData function with better error handling
  const fetchLinkedInProfileData = async (profileUrl) => {
    try {
      const token = localStorage.getItem('token');
      const username = extractUsername(profileUrl);

      if (!username) {
        throw new Error('Invalid LinkedIn profile URL');
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/linkedin/profile-data`,
        { 
          profileUrl,
          username // Add username to the request
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data) {
      setLinkedinProfileData(response.data);
      } else {
        console.log('No profile data returned from API');
      }
    } catch (err) {
      console.error('Error fetching LinkedIn profile data:', err);
      // Don't set error state here as this is not critical
      // Just log the error and continue
    }
  };

  // Update fetchPostsFromAPI function with better error handling
  const fetchPostsFromAPI = async (username) => {
    try {
      console.log('Fetching posts from API for username:', username);
      const response = await api.get('/api/linkedin/profile/posts', {
        params: {
          username,
          saveToDatabase: true
        }
      });

      if (response.data.metadata?.error) {
        throw new Error(response.data.metadata.error);
      }

      const postsArray = Array.isArray(response.data) 
        ? response.data
        : (response.data.posts && Array.isArray(response.data.posts))
          ? response.data.posts
          : null;
          
      if (!postsArray) {
        throw new Error('Invalid response format from server');
      }

      if (postsArray.length === 0) {
        setError('No posts found for this profile. Make sure the profile is public and has posts.');
        setPosts([]);
        return;
      }

      const formattedPosts = formatPosts(postsArray);
      console.log('Formatted posts from API:', formattedPosts.length);
      setPosts(formattedPosts);
    } catch (error) {
      console.error('Failed to fetch posts from API:', error);
      setError(
        error.response?.data?.message || 
        error.message || 
        'Failed to fetch posts from LinkedIn. Please make sure the profile URL is correct and the profile is public.'
      );
      setPosts([]);
    }
  };

  // Update the handleFetchPosts function to use fetchPostsForUsername
  const handleFetchPosts = async () => {
    const username = extractUsername(profileUrl);
    if (!username) {
      setError('Please enter a valid LinkedIn profile URL or username');
      return;
    }
    
    fetchPostsFromDatabase(username);
  };

  // Update the determinePostFormat function with logging
  const determinePostFormat = (post) => {
    // Check for null or undefined post
    if (!post) {
      console.warn('Null or undefined post in determinePostFormat');
      return 'Text';
    }
    
    // Add detailed logging
    console.log('Determining format for post:', {
      id: post.id || post.urn,
      hasDocument: !!post.document,
      mediaType: post.media?.type,
      mediaUrl: post.media?.url,
      hasMediaItems: !!post.media?.items,
      fullMediaObject: post.media,
      text_url: post.text_url
    });

    // First check for image URLs
    if (post.text_url || post.media?.url?.includes('/image/') || 
        post.media?.url?.includes('.jpg') || post.media?.url?.includes('.png') || 
        post.media?.url?.includes('.jpeg') || post.media?.type === 'image') {
      console.log('Detected as Image');
      return 'Image';
    }
    
    // Then check for video
    if (post.media?.type === 'video' || post.media?.url?.includes('video')) {
      console.log('Detected as Video');
      return 'Video';
    }
    
    // Check for carousel/multiple items or document (treat documents as carousels)
    if ((post.media?.items && post.media.items.length > 0) || 
        post.media?.type === 'document' || post.document) {
      console.log('Detected as Carousel');
      return 'Carousel';
    }

    console.log('Detected as Text - no media matches found');
    return 'Text';
  };

  // Update formatPosts function to properly handle bot response format
  const formatPosts = (posts) => {
    if (!Array.isArray(posts)) {
      console.error('Invalid posts data:', posts);
      return [];
    }

    return posts.map(post => {
      console.log('Raw post data:', post);

      // Parse the post date properly
      let postDate = new Date();
      try {
        // Check if we have the postedAt object with date
        if (post.postedAt?.date) {
          const dateStr = post.postedAt.date;
          console.log('Found date string:', dateStr);
          
          // Try parsing the specific format "YYYY-MM-DD HH:mm:ss"
          const [datePart, timePart] = dateStr.split(' ');
          if (datePart && timePart) {
            postDate = new Date(`${datePart}T${timePart}`);
          } else {
            postDate = new Date(dateStr);
          }
        } else if (post.postedAt?.timestamp) {
          postDate = new Date(parseInt(post.postedAt.timestamp));
        } else if (post.created_at) {
          postDate = new Date(post.created_at);
        }

        // Validate the parsed date
        if (isNaN(postDate.getTime())) {
          console.error('Invalid date parsed:', {
            original: post.postedAt,
            parsed: postDate
          });
          // Keep the original date string if available
          if (post.postedAt?.date) {
            postDate = {
              raw: post.postedAt.date,
              parsed: false
            };
          }
        }
      } catch (e) {
        console.error('Error parsing date:', e, post.postedAt);
        if (post.postedAt?.date) {
          postDate = {
            raw: post.postedAt.date,
            parsed: false
          };
        }
      }

      const formattedPost = {
        id: post.id || post.urn || `post-${Date.now()}-${Math.random()}`,
        url: post.url || '',
        content: post.content || post.text || post.description || '',
        format: post.format === 'Document' ? 'Carousel' : determinePostFormat(post),
        media: {
          ...post.media,
          url: post.text_url || post.media?.url || post.media?.thumbnail || post.thumbnail || '',
          thumbnail: post.media?.thumbnail || post.thumbnail || post.text_url || post.media?.url || '',
          type: post.media?.type === 'document' ? 'carousel' : post.media?.type || determinePostFormat(post).toLowerCase(),
          items: post.media?.items || []
        },
        document: post.document || null,
        author: {
          name: post.author?.name || 
                (post.author?.first_name && post.author?.last_name ? 
                  `${post.author.first_name} ${post.author.last_name}`.trim() : 
                  post.data?.author?.name || 
                  post.author?.headline?.split(' at ')[0] || 
                  'Unknown'),
          headline: post.author?.headline || post.data?.author?.occupation || '',
          profilePicture: post.author?.profilePicture || 
                         post.author?.profile_picture || 
                         post.data?.author?.profilePicture || 
                         post.author?.image || 
                         post.author?.imageUrl || 
                         post.author?.pictureUrl || ''
        },
        stats: {
          likes: post.stats?.likes || post.stats?.total_reactions || 0,
          comments: post.stats?.comments || 0,
          reposts: post.stats?.reposts || 0,
          totalReactions: post.stats?.totalReactions || post.stats?.total_reactions || post.stats?.likes || 0
        },
        postedAt: {
          date: postDate.raw || postDate.toISOString(),
          relative: '',
          timestamp: post.postedAt?.timestamp || postDate.getTime(),
          originalDate: post.postedAt?.date // Keep the original date string
        }
      };

      console.log('Formatted post with date:', {
        originalDate: post.postedAt?.date,
        parsedDate: postDate,
        formattedDate: formattedPost.postedAt
      });
      return formattedPost;
    });
  };

  // Add helper function for relative time
  const getRelativeTime = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    // If the date is in the future (within reasonable bounds to account for time zones)
    if (diffInSeconds < -86400) { // More than a day in the future
      return date.toLocaleDateString('en-US', { 
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
    
    const diffInMinutes = Math.floor(Math.abs(diffInSeconds) / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays > 30) {
      return date.toLocaleDateString('en-US', { 
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } else if (diffInDays > 0) {
      return `${diffInDays}d ago`;
    } else if (diffInHours > 0) {
      return `${diffInHours}h ago`;
    } else if (diffInMinutes > 0) {
      return `${diffInMinutes}m ago`;
    } else {
      return 'Just now';
    }
  };

  // Update the formatDateTime function
  const formatDateTime = (dateString) => {
    try {
      if (!dateString) {
        return { date: 'N/A', time: 'N/A' };
      }

      // Handle the specific format "YYYY-MM-DD HH:mm:ss"
      if (dateString.includes(' ')) {
        const [datePart, timePart] = dateString.split(' ');
        const [year, month, day] = datePart.split('-').map(num => parseInt(num));
        const [hours, minutes] = timePart.split(':').map(num => parseInt(num));
        
        const date = new Date(year, month - 1, day, hours, minutes);
        if (!isNaN(date.getTime())) {
          return {
            date: date.toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
            }),
            time: date.toLocaleTimeString('en-US', { 
              hour: 'numeric', 
              minute: '2-digit',
              hour12: true 
            }).toLowerCase()
          };
        }
      }

      // Fallback to direct parsing
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return {
          date: date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
          }),
          time: date.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit',
            hour12: true 
          }).toLowerCase()
        };
      }

      // If all parsing fails, return the original parts
      const parts = dateString.split(' ');
      return {
        date: parts[0] || dateString,
        time: parts[1] || ''
      };
    } catch (error) {
      console.error('Error formatting date:', error);
      return { date: dateString, time: '' };
    }
  };

  // Update the renderPostCard function
  const renderPostCard = (post) => (
    <PostCard
      post={post}
      onCommentClick={() => handleOpenCommentDialog(post)}
      onRemixClick={() => handleRemixClick(post)}
    />
  );

  const handleConnectLinkedIn = () => {
    // Will implement LinkedIn OAuth flow
    const scopes = [
      'openid',
      'profile',
      'r_ads_reporting',
      'r_organization_social',
      'rw_organization_admin',
      'w_member_social',
      'r_ads',
      'w_organization_social',
      'rw_ads',
      'r_basicprofile',
      'r_organization_admin',
      'email',
      'r_1st_connections_size'
    ].join(' ');

    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    const redirectUri = `${window.location.origin}/linkedin-callback`;
    const state = 'metrics'; // To identify this flow in callback

    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scopes}`;

    window.location.href = authUrl;
  };

  // Update the function to handle local loading too
  const handleGetMetrics = async () => {
    try {
      setLoading(true);
      setError(null);

      if (linkedinProfile) {
        const username = extractUsername(linkedinProfile);
        if (username) {
          await fetchPostsFromDatabase(username);
        }
      }
    } catch (error) {
      console.error('Failed to fetch metrics:', error);
      setError(error.response?.data?.message || 'Failed to fetch metrics');
    } finally {
      setLoading(false);
    }
  };

  const extractUsername = (url) => {
    // Handle both full URLs and just usernames
    if (!url) return '';
    if (!url.includes('linkedin.com')) return url;
    
    const matches = url.match(/linkedin\.com\/in\/([^\/\?]+)/);
    return matches ? matches[1] : url;
  };

  // Tab panels
  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index} style={{ marginTop: '20px' }}>
      {value === index && children}
    </div>
  );

  const Carousel = ({ media }) => {
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = media.length;

    const handleNext = () => {
      setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
      setActiveStep((prevStep) => prevStep - 1);
    };

    // Early return if no media
    if (!media || media.length === 0) return null;

    // Get current slide URL, handling both document and media item formats
    const getCurrentSlideUrl = () => {
      const currentItem = media[activeStep];
      return currentItem.url || currentItem.thumbnail || '';
    };

    return (
      <Box sx={{ position: 'relative' }}>
        <Box
          component="img"
          src={getCurrentSlideUrl()}
          alt={`Slide ${activeStep + 1}`}
          sx={{
            width: '100%',
            borderRadius: 2,
            display: 'block',
            maxHeight: '600px',
            objectFit: 'contain'
          }}
        />
        {maxSteps > 1 && (
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{
            bgcolor: 'transparent',
            position: 'absolute',
            bottom: 0,
            width: '100%'
          }}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
                sx={{ color: 'white', bgcolor: 'rgba(0,0,0,0.5)' }}
            >
                Next
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
                sx={{ color: 'white', bgcolor: 'rgba(0,0,0,0.5)' }}
            >
              <KeyboardArrowLeft />
                Back
            </Button>
          }
        />
        )}
      </Box>
    );
  };

  // Update PostModal component
  const PostModal = ({ post, onClose }) => {
    if (!post) return null;
    
    // Update postFormat to always show Carousel instead of Document
    const postFormat = post.format === 'Document' ? 'Carousel' : determinePostFormat(post);
    
    const getBestMediaUrl = () => {
      if (postFormat === 'Image') {
        return post.text_url || post.media?.url || post.media?.thumbnail || post.thumbnail || '';
      }
      if (postFormat === 'Video') {
        return post.media?.thumbnail || post.thumbnail || post.media?.url || '';
      }
      if (postFormat === 'Carousel') {
        return post.document?.thumbnail || post.media?.thumbnail || post.thumbnail || '';
      }
      return '';
    };

    const mediaUrl = getBestMediaUrl();
    
    return (
    <Dialog 
      open={!!post} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          margin: { xs: 2, sm: 4 },
          maxHeight: 'calc(100vh - 100px)',
          width: '95%',
          borderRadius: 2,
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(0, 0, 0, 0.05)'
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          fontSize: '1.25rem',
          fontWeight: 600,
          pb: 1,
          pt: 2.5,
          px: 3,
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          Post Details
          {postFormat && (
            <Chip
              label={postFormat}
              size="small"
              variant="filled"
              sx={{
                ml: 1,
                bgcolor: theme => {
                  switch(postFormat) {
                    case 'Carousel': return 'rgba(56, 161, 105, 0.1)';
                    case 'Image': return 'rgba(72, 144, 254, 0.1)';
                    case 'Video': return 'rgba(237, 137, 54, 0.1)';
                    default: return 'rgba(160, 174, 192, 0.1)';
                  }
                },
                color: theme => {
                  switch(postFormat) {
                    case 'Carousel': return '#38A169';
                    case 'Image': return '#4890fe';
                    case 'Video': return '#ED8936';
                    default: return '#718096';
                  }
                }
              }}
            />
          )}
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Avatar 
              src={post.author.profilePicture} 
              sx={{ 
                width: 48, 
                height: 48, 
                mr: 2,
                border: '2px solid rgba(0, 0, 0, 0.05)'
              }}
            >
              {post.author.name ? post.author.name[0] : <PersonIcon />}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {post.author.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {post.author.headline}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {post.postedAt.date}
              </Typography>
            </Box>
          </Box>

          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', mb: 3 }}>
            {post.content}
          </Typography>

          {mediaUrl && (
            <Box sx={{ 
              mt: 2, 
              mb: 3,
              textAlign: 'center',
              '& img': {
                maxWidth: '100%',
                maxHeight: 500,
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
              }
            }}>
              <img 
                src={mediaUrl} 
                alt="Post content" 
                onError={(e) => {
                  console.error('Image load error:', e);
                  if (post.media?.url) e.target.src = post.media.url;
                }}
              />
            </Box>
          )}

          {postFormat === 'Carousel' && post.media?.items && post.media.items.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Carousel media={post.media.items} />
            </Box>
          )}

          {/* Stats section */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            pt: 2,
            mt: 2,
            borderTop: '1px solid rgba(0, 0, 0, 0.06)'
          }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Chip
                icon={<ThumbUpIcon fontSize="small" />}
                label={post.stats.totalReactions}
                size="small"
                variant="filled"
                sx={{
                  bgcolor: 'rgba(72, 144, 254, 0.1)',
                  color: '#4890fe',
                  fontWeight: 600
                }}
              />
              <Chip
                icon={<CommentIcon fontSize="small" />}
                label={post.stats.comments}
                size="small"
                variant="filled"
                sx={{
                  bgcolor: 'rgba(56, 161, 105, 0.1)',
                  color: '#38A169',
                  fontWeight: 600
                }}
              />
              <Chip
                icon={<ShareIcon fontSize="small" />}
                label={post.stats.reposts}
                size="small"
                variant="filled"
                sx={{
                  bgcolor: 'rgba(237, 137, 54, 0.1)',
                  color: '#ED8936',
                  fontWeight: 600
                }}
              />
            </Box>
            <Button 
              variant="outlined" 
              href={post.url} 
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<LaunchIcon />}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                borderColor: '#4890fe',
                color: '#4890fe',
                '&:hover': {
                  borderColor: '#3a7ad9',
                  bgcolor: 'rgba(72, 144, 254, 0.04)'
                }
              }}
            >
              View on LinkedIn
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
  };

  // Add sorting function
  const handleSort = (key) => {
    let direction = 'desc';
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') direction = 'asc';
      else if (sortConfig.direction === 'asc') direction = 'neutral';
      else direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Add filtering function
  const getFilteredAndSortedPosts = (posts) => {
    // Create a safe copy of posts with default values for missing properties
    let filteredPosts = posts.map(post => ({
      ...post,
      content: post.content || '',
      author: post.author || { name: 'Unknown' },
      postedAt: post.postedAt || { 
        date: new Date().toISOString(),
        relative: '', // Empty string instead of 'N/A'
        timestamp: Date.now()
      },
      stats: post.stats || {
        likes: 0,
        comments: 0,
        reposts: 0,
        totalReactions: 0
      }
    }));

    // Ensure totalReactions is set if not already present
    filteredPosts = filteredPosts.map(post => ({
      ...post,
      stats: {
        ...post.stats,
        totalReactions: post.stats.totalReactions || post.stats.likes || 0
      }
    }));

    // Apply format filter
    if (filters.format !== 'all') {
      filteredPosts = filteredPosts.filter(post => {
        const postFormat = determinePostFormat(post);
        return postFormat === filters.format;
      });
    }

    // Apply search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filteredPosts = filteredPosts.filter(post =>
        post.content?.toLowerCase().includes(searchLower) ||
        post.author?.name?.toLowerCase().includes(searchLower)
      );
    }

    // Apply sorting only if direction is not neutral
    if (sortConfig.key && sortConfig.direction !== 'neutral') {
      filteredPosts = [...filteredPosts].sort((a, b) => {
        // Handle nested properties like stats.likes or postedAt.date
        const keyParts = sortConfig.key.split('.');
        let valueA = a;
        let valueB = b;
        
        for (const part of keyParts) {
          valueA = valueA?.[part] ?? null;
          valueB = valueB?.[part] ?? null;
        }
        
        // Handle various data types
        if (valueA === null && valueB === null) return 0;
        if (valueA === null) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valueB === null) return sortConfig.direction === 'asc' ? 1 : -1;
        
        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return sortConfig.direction === 'asc' 
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }
        
        // Handle date strings
        if (sortConfig.key.includes('date')) {
          const dateA = new Date(valueA).getTime();
          const dateB = new Date(valueB).getTime();
          return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
        }
        
        // Default numeric comparison
        return sortConfig.direction === 'asc' ? valueA - valueB : valueB - valueA;
      });
    }

    return filteredPosts;
  };

  // Update PostsTable component with separate date and time columns
  const PostsTable = ({ posts }) => {
    const SortableHeader = ({ label, sortKey }) => {
      const isActive = sortConfig.key === sortKey;
      return (
        <TableCell align="center">
          <Button
            onClick={() => handleSort(sortKey)}
            endIcon={
              isActive ? (
                sortConfig.direction === 'asc' ? (
                  <ArrowUpwardIcon />
                ) : sortConfig.direction === 'desc' ? (
                  <ArrowDownwardIcon />
                ) : null
              ) : null
            }
            sx={{ 
              textTransform: 'none',
              color: isActive ? '#4890fe' : '#4A5568',
              fontWeight: isActive ? 600 : 500,
              '&:hover': {
                backgroundColor: 'rgba(72, 144, 254, 0.04)'
              }
            }}
          >
            {label}
          </Button>
        </TableCell>
      );
    };

    // Helper function to format date and time with defensive coding
    const formatDateTime = (dateString) => {
      try {
        if (!dateString) {
          console.warn('Missing date string in formatDateTime', dateString);
          return {
            date: 'N/A',
            time: 'N/A'
          };
        }
        
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
          console.warn('Invalid date in formatDateTime', dateString);
          return {
            date: 'N/A',
            time: 'N/A'
          };
        }
        
        return {
          date: date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
          }),
          time: date.toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: true
          })
        };
      } catch (error) {
        console.error('Error formatting date', error);
        return {
          date: 'N/A',
          time: 'N/A'
        };
      }
    };
    
    // Function to get thumbnail URL from post (checks multiple sources)
    const getThumbnailUrl = (post) => {
      // Check if it's a document/carousel post first
      if (post.format === 'Carousel' || post.media?.type === 'document') {  // Changed from 'Document' to 'Carousel'
        const documentThumbnail = post.document?.thumbnail || post.media?.thumbnail;
        console.log('Carousel thumbnail for post:', post.id, documentThumbnail);
        return documentThumbnail;
      }
      
      // Then check for other media types
      return post.media?.thumbnail || post.media?.url || null;
    };
    
    // Function to determine post type with additional logging
    const getPostType = (post) => {
      if (post.format === 'Document' || post.media?.type === 'document' || post.document) {
        return 'Carousel';
      }
      return post.format || determinePostFormat(post);
    };

    return (
      <TableContainer 
        component={Paper}
        sx={{ 
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
          borderRadius: 2,
          border: '1px solid rgba(0, 0, 0, 0.05)',
          overflow: 'hidden'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <SortableHeader label="Date" sortKey="postedAt.date" />
              <TableCell align="center">Time</TableCell>
              <TableCell align="center">Preview</TableCell>
              <TableCell align="center">Content</TableCell>
              <TableCell align="center">Type</TableCell>
              <SortableHeader label="Reactions" sortKey="stats.totalReactions" />
              <SortableHeader label="Comments" sortKey="stats.comments" />
              <SortableHeader label="Reposts" sortKey="stats.reposts" />
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {posts.map((post) => {
              // Create a complete post object with all required properties
              const safePost = {
                ...post,
                id: post.id || post.urn || `post-${Math.random()}`,
                url: post.url || '',
                content: post.content || '',
                format: post.format || determinePostFormat(post),
                media: {
                  ...post.media,
                  url: post.text_url || post.media?.url || post.media?.thumbnail || post.thumbnail || '',
                  thumbnail: post.media?.thumbnail || post.thumbnail || post.text_url || post.media?.url || '',
                  type: post.media?.type || determinePostFormat(post).toLowerCase(),
                  items: post.media?.items || []
                },
                document: post.document || null,
                author: {
                  name: post.author?.name || 
                        (post.author?.first_name && post.author?.last_name ? 
                          `${post.author.first_name} ${post.author.last_name}`.trim() : 
                          post.data?.author?.name || 
                          post.author?.headline?.split(' at ')[0] || 
                          'Unknown'),
                  headline: post.author?.headline || post.data?.author?.occupation || '',
                  profilePicture: post.author?.profile_picture || 
                              post.author?.profilePicture || 
                              post.data?.author?.profilePicture || 
                              post.author?.image || 
                              post.author?.imageUrl || 
                              post.author?.pictureUrl || ''
                },
                stats: {
                  likes: post.stats?.likes || post.stats?.total_reactions || 0,
                  comments: post.stats?.comments || 0,
                  reposts: post.stats?.reposts || 0,
                  totalReactions: post.stats?.totalReactions || post.stats?.total_reactions || post.stats?.likes || 0
                },
                postedAt: post.postedAt || { 
                  date: new Date().toISOString(),
                  relative: '',
                  timestamp: Date.now()
                },
                document_data: post.document_data || post.document || null,
                thumbnail: post.thumbnail || post.media?.thumbnail || post.document?.thumbnail || null
              };
              
              // Format the date and time with error handling
              const { date, time } = formatDateTime(safePost.postedAt.date);
              
              // Get thumbnail and post type
              const thumbnailUrl = getThumbnailUrl(safePost);
              const postType = getPostType(safePost);
              
              return (
                <TableRow 
                  key={safePost.id}
                  onClick={() => setSelectedPost(safePost)}
                  sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}
                >
                  <TableCell align="center">
                    <Typography variant="body2">
                      {date}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {time}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ width: 100 }}>
                    {thumbnailUrl ? (
                      <Box
                        component="img"
                        src={thumbnailUrl}
                        alt="Post preview"
                        sx={{
                          width: 80,
                          height: 80,
                          objectFit: 'cover',
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor: 'divider'
                        }}
                        onError={(e) => {
                          console.log('Image load error:', e);
                          e.target.src = safePost.media?.url || '';
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor: 'divider',
                          bgcolor: 'grey.50',
                          p: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          color: 'text.secondary',
                          overflow: 'hidden'
                        }}
                      >
                        {safePost.content?.slice(0, 50) || 'No content'}...
                      </Box>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Typography
                      variant="body2"
                      sx={{
                        maxWidth: 300,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        margin: '0 auto'  // Center the text container
                      }}
                    >
                      {safePost.content}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip 
                      label={postType} 
                      size="small"
                      variant="filled"
                      sx={{
                        bgcolor: theme => {
                          switch(postType) {
                            case 'Carousel': return 'rgba(56, 161, 105, 0.1)';
                            case 'Image': return 'rgba(72, 144, 254, 0.1)';
                            case 'Video': return 'rgba(237, 137, 54, 0.1)';
                            default: return 'rgba(160, 174, 192, 0.1)';
                          }
                        },
                        color: theme => {
                          switch(postType) {
                            case 'Carousel': return '#38A169';
                            case 'Image': return '#4890fe';
                            case 'Video': return '#ED8936';
                            default: return '#718096';
                          }
                        },
                        fontWeight: 600
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">{safePost.stats.totalReactions}</TableCell>
                  <TableCell align="center">{safePost.stats.comments}</TableCell>
                  <TableCell align="center">{safePost.stats.reposts}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small" 
                      href={safePost.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        '&:hover': {
                          backgroundColor: 'rgba(72, 144, 254, 0.1)'
                        }
                      }}
                    >
                      <LaunchIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // Update the generateWordCloudData function
  const generateWordCloudData = (posts) => {
    // Expanded stop words list
    const stopWords = new Set([
      'and', 'the', 'for', 'that', 'this', 'are', 'with', 'you', 'its', 'was', 'has',
      'will', 'can', 'but', 'not', 'they', 'what', 'when', 'how', 'from', 'have',
      'had', 'all', 'why', 'where', 'who', 'which', 'there', 'here', 'than', 'them',
      'your', 'our', 'their', 'these', 'those', 'been', 'were', 'would', 'could',
      'should', 'just', 'now', 'then', 'some', 'like', 'into', 'out', 'about',
      'more', 'other', 'such', 'only', 'any', 'too', 'very', 'also'
    ]);

    const words = posts
      .map(post => post.content || '')
      .join(' ')
      .toLowerCase()
      // Remove URLs
      .replace(/https?:\/\/[^\s]+/g, '')
      // Remove special characters but keep hyphens for compound words
      .replace(/[^a-zA-Z\s-]/g, ' ')
      // Split on spaces and hyphens
      .split(/[\s-]+/)
      .filter(word => 
        word.length > 3 && 
        !stopWords.has(word) &&
        !/^\d+$/.test(word) && // Remove numbers
        !/^[a-z]$/i.test(word) // Remove single letters
      );

    const wordCount = {};
    words.forEach(word => {
      wordCount[word] = (wordCount[word] || 0) + 1;
    });

    return Object.entries(wordCount)
      .map(([value, count]) => ({
        value,
        count: count * 10, // Increase size multiplier for better visibility
        key: value
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 30); // Reduce to top 30 words for better clarity
  };

  // Add this helper function at the top level
  const extractHashtags = (posts) => {
    const hashtagStats = {};
    
    posts.forEach(post => {
      const hashtags = (post.content || '').match(/#[\w-]+/g) || [];
      hashtags.forEach(tag => {
        if (!hashtagStats[tag]) {
          hashtagStats[tag] = {
            count: 0,
            totalEngagement: 0,
            posts: []
          };
        }
        hashtagStats[tag].count++;
        hashtagStats[tag].totalEngagement += 
          post.stats.totalReactions + 
          post.stats.comments + 
          post.stats?.reposts || 0;
        hashtagStats[tag].posts.push({
          content: post.content?.split('\n')[0],
          engagement: post.stats.totalReactions + post.stats.comments + (post.stats?.reposts || 0),
          url: post.url
        });
      });
    });

    return Object.entries(hashtagStats)
      .map(([tag, stats]) => ({
        tag,
        count: stats.count,
        avgEngagement: Math.round(stats.totalEngagement / stats.count),
        posts: stats.posts.sort((a, b) => b.engagement - a.engagement).slice(0, 3)
      }))
      .sort((a, b) => b.count - a.count);
  };

  // Update the AnalyticsTab component
  const AnalyticsTab = ({ posts }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    // Ensure posts is an array
    const safePostsArray = Array.isArray(posts) ? posts : [];
    
    // Calculate engagement metrics
    const totalReactions = safePostsArray.reduce((sum, post) => sum + (post.stats?.totalReactions || 0), 0);
    const totalComments = safePostsArray.reduce((sum, post) => sum + (post.stats?.comments || 0), 0);
    const totalReposts = safePostsArray.reduce((sum, post) => sum + (post.stats?.reposts || 0), 0);
    const totalEngagement = totalReactions + totalComments + totalReposts;
    
    // Calculate average engagement per post
    const avgReactions = safePostsArray.length ? (totalReactions / safePostsArray.length).toFixed(1) : '0.0';
    const avgComments = safePostsArray.length ? (totalComments / safePostsArray.length).toFixed(1) : '0.0';
    const avgReposts = safePostsArray.length ? (totalReposts / safePostsArray.length).toFixed(1) : '0.0';
    
    // Calculate engagement rate (total engagement / total posts)
    const engagementRate = safePostsArray.length ? ((totalEngagement / safePostsArray.length) / 100).toFixed(2) : '0.00';
    
    // Calculate post frequency
    const postDates = safePostsArray.map(post => new Date(post.postedAt?.date || Date.now()).toISOString().split('T')[0]);
    const uniqueDates = [...new Set(postDates)];
    const postsPerDay = uniqueDates.length ? (safePostsArray.length / uniqueDates.length).toFixed(1) : '0.0';
    
    // Calculate best posting time
    const postHours = safePostsArray.map(post => new Date(post.postedAt?.date || Date.now()).getHours());
    const hourCounts = postHours.reduce((acc, hour) => {
      acc[hour] = (acc[hour] || 0) + 1;
      return acc;
    }, {});
    
    const bestHour = Object.entries(hourCounts)
      .sort((a, b) => b[1] - a[1])[0]?.[0] || 9;
    
    // Format the best hour for display
    const formatBestHour = (hour) => {
      const hourNum = parseInt(hour);
      if (hourNum === 0) return '12 AM';
      if (hourNum === 12) return '12 PM';
      return hourNum < 12 ? `${hourNum} AM` : `${hourNum - 12} PM`;
    };
    
    // Prepare data for post formats pie chart
    const postFormats = safePostsArray.map(post => {
      // Log details about the post format to help with debugging
      console.log('Post format analysis:', {
        id: post.id,
        format: post.format,
        hasMedia: !!post.media,
        mediaType: post.media?.type,
        hasDocument: !!post.document
      });
      
      // First check if the post already has a valid format property
      if (post.format && ['Image', 'Video', 'Carousel', 'Text'].includes(post.format)) {
        return post.format;
      }
      
      // If no valid format, use the determinePostFormat function
      return determinePostFormat(post);
    });
    
    console.log('All post formats:', postFormats);
    
    const formatDistribution = postFormats.reduce((acc, format) => {
      acc[format] = (acc[format] || 0) + 1;
      return acc;
    }, {});
    
    console.log('Format distribution:', formatDistribution);
    
    const postFormatData = Object.entries(formatDistribution).map(([format, count]) => ({
      name: format,
      value: safePostsArray.length ? Math.round((count / safePostsArray.length) * 100) : 0
    }));
    
    // Prepare data for posting times heatmap
    const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const hourLabels = ['06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00'];
    
    // Initialize the heatmap data with zeros
    const postingTimesHeatmap = Array(7).fill().map(() => Array(8).fill(0));
    
    // Fill the heatmap with actual data
    safePostsArray.forEach(post => {
      if (!post.postedAt?.date) return;
      const date = new Date(post.postedAt.date);
      const day = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const hour = date.getHours();
      
      // Map the day to our array (making Monday index 0)
      const dayIndex = day === 0 ? 6 : day - 1;
      
      // Map the hour to our array (6am = 0, 8am = 1, etc.)
      let hourIndex;
      if (hour >= 6 && hour < 8) hourIndex = 0;
      else if (hour >= 8 && hour < 10) hourIndex = 1;
      else if (hour >= 10 && hour < 12) hourIndex = 2;
      else if (hour >= 12 && hour < 14) hourIndex = 3;
      else if (hour >= 14 && hour < 16) hourIndex = 4;
      else if (hour >= 16 && hour < 18) hourIndex = 5;
      else if (hour >= 18 && hour < 20) hourIndex = 6;
      else if (hour >= 20 && hour < 22) hourIndex = 7;
      else return; // Skip hours outside our range
      
      // Increment the count for this day/hour combination
      if (dayIndex >= 0 && dayIndex < 7 && hourIndex >= 0 && hourIndex < 8) {
        postingTimesHeatmap[dayIndex][hourIndex]++;
      }
    });
    
    // Convert the heatmap data to the format needed for visualization
    const postingTimesData = [];
    for (let day = 0; day < 7; day++) {
      for (let hour = 0; hour < 8; hour++) {
        postingTimesData.push({
          day: dayNames[day],
          hour: hourLabels[hour],
          value: postingTimesHeatmap[day][hour]
        });
      }
    }
    
    // Extract main themes from post content
    const extractThemes = (posts) => {
      if (!Array.isArray(posts) || posts.length === 0) {
        return [
          { name: 'No Data', value: 100 }
        ];
      }
      
      // Extract all words from posts and count their frequency
      const wordCounts = {};
      const stopWords = new Set([
        'a', 'an', 'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'with', 
        'by', 'about', 'as', 'of', 'from', 'this', 'that', 'these', 'those', 'is', 'are',
        'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'do', 'does', 'did',
        'will', 'would', 'shall', 'should', 'can', 'could', 'may', 'might', 'must', 'i',
        'you', 'he', 'she', 'it', 'we', 'they', 'me', 'him', 'her', 'us', 'them', 'my',
        'your', 'his', 'its', 'our', 'their', 'mine', 'yours', 'hers', 'ours', 'theirs',
        'what', 'which', 'who', 'whom', 'whose', 'when', 'where', 'why', 'how'
      ]);
      
      // Process each post
      posts.forEach(post => {
        if (!post.content) return;
        
        // Extract words, remove punctuation, convert to lowercase
        const words = post.content.toLowerCase()
          .replace(/[^\w\s#]/g, '') // Keep hashtags
          .split(/\s+/);
        
        // Count word frequency, excluding stop words and short words
        words.forEach(word => {
          // Skip stop words and short words (less than 4 chars) unless they're hashtags
          if ((word.length < 4 && !word.startsWith('#')) || stopWords.has(word)) return;
          
          // Remove # from hashtags for better grouping
          const cleanWord = word.startsWith('#') ? word.substring(1) : word;
          
          // Count the word
          wordCounts[cleanWord] = (wordCounts[cleanWord] || 0) + 1;
        });
      });
      
      // Group related words into themes
      const themes = {};
      
      // Define some theme categories and their related keywords
      const themeCategories = {
        'Marketing': ['marketing', 'brand', 'content', 'social', 'media', 'digital', 'seo', 'audience'],
        'Technology': ['tech', 'technology', 'innovation', 'digital', 'software', 'data', 'ai', 'automation'],
        'Leadership': ['leadership', 'management', 'team', 'leading', 'strategy', 'vision', 'executive'],
        'Career': ['career', 'job', 'professional', 'skills', 'resume', 'interview', 'hiring'],
        'Business': ['business', 'entrepreneur', 'startup', 'company', 'industry', 'market', 'growth'],
        'Design': ['design', 'graphic', 'ui', 'ux', 'visual', 'creative', 'typography'],
        'LinkedIn': ['linkedin', 'network', 'profile', 'connection', 'post', 'engagement'],
        'Personal Development': ['growth', 'learning', 'mindset', 'goals', 'success', 'motivation']
      };
      
      // Initialize theme counts
      Object.keys(themeCategories).forEach(theme => {
        themes[theme] = 0;
      });
      
      // Assign words to themes based on keywords
      Object.entries(wordCounts).forEach(([word, count]) => {
        let assigned = false;
        
        // Check if the word belongs to any theme
        Object.entries(themeCategories).forEach(([theme, keywords]) => {
          if (keywords.some(keyword => word.includes(keyword) || keyword.includes(word))) {
            themes[theme] += count;
            assigned = true;
          }
        });
        
        // If the word is frequent but not assigned to any theme, create a new theme
        if (!assigned && count > 3) {
          // Capitalize first letter for display
          const displayWord = word.charAt(0).toUpperCase() + word.slice(1);
          themes[displayWord] = count;
        }
      });
      
      // Convert to percentage and format for chart
      return Object.entries(themes)
        .filter(([_, count]) => count > 0)
        .map(([theme, count]) => ({
          name: theme,
          value: Math.round((count / Object.values(themes).reduce((sum, c) => sum + c, 0)) * 100)
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 5); // Take top 5 themes
    };
    
    const mainThemesData = extractThemes(safePostsArray);
    
    // Prepare data for content type radar chart
    const contentTypeData = [
      { subject: 'Actionable', A: 0 },
      { subject: 'Aspirational', A: 0 },
      { subject: 'Introspective', A: 0 },
      { subject: 'Promotional', A: 0 }
    ];
    
    // Function to determine content type (simplified)
    const analyzeContentType = (post) => {
      const content = (post.content || '').toLowerCase();
      
      // Simple keyword matching for content types
      const actionableKeywords = ['how to', 'tips', 'guide', 'steps', 'learn', 'improve'];
      const aspirationalKeywords = ['future', 'goal', 'dream', 'aspire', 'vision', 'success'];
      const introspectiveKeywords = ['reflect', 'think', 'believe', 'perspective', 'opinion'];
      const promotionalKeywords = ['offer', 'discount', 'promotion', 'launch', 'new', 'introducing'];
      
      if (actionableKeywords.some(keyword => content.includes(keyword))) {
        contentTypeData[0].A += 25;
      }
      if (aspirationalKeywords.some(keyword => content.includes(keyword))) {
        contentTypeData[1].A += 25;
      }
      if (introspectiveKeywords.some(keyword => content.includes(keyword))) {
        contentTypeData[2].A += 25;
      }
      if (promotionalKeywords.some(keyword => content.includes(keyword))) {
        contentTypeData[3].A += 25;
      }
    };
    
    // Analyze each post for content type
    safePostsArray.forEach(post => {
      analyzeContentType(post);
    });
    
    // Normalize the values
    contentTypeData.forEach(item => {
      item.A = safePostsArray.length ? Math.min(100, Math.max(0, item.A / safePostsArray.length)) : 0;
    });
    
    // Prepare data for charts
    const engagementData = [
      { name: 'Reactions', value: totalReactions },
      { name: 'Comments', value: totalComments },
      { name: 'Reposts', value: totalReposts }
    ];
    
    // Prepare data for post type distribution
    const postTypes = safePostsArray.map(post => {
      // Use the same approach as before - first check for valid format property
      if (post.format && ['Image', 'Video', 'Carousel', 'Text'].includes(post.format)) {
        return post.format;
      }
      return determinePostFormat(post);
    });
    
    console.log('Second post type detection:', postTypes);
    
    const typeDistribution = postTypes.reduce((acc, type) => {
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});
    
    console.log('Second type distribution:', typeDistribution);
    
    const postTypeData = Object.entries(typeDistribution).map(([type, count]) => ({
      name: type,
      value: count
    }));
    
    // Prepare data for engagement over time
    const timelineData = safePostsArray
      .sort((a, b) => new Date(a.postedAt?.date || Date.now()) - new Date(b.postedAt?.date || Date.now()))
      .map(post => ({
        date: new Date(post.postedAt?.date || Date.now()).toLocaleDateString(),
        reactions: post.stats?.totalReactions || 0,
        comments: post.stats?.comments || 0,
        reposts: post.stats?.reposts || 0,
        total: (post.stats?.totalReactions || 0) + (post.stats?.comments || 0) + (post.stats?.reposts || 0)
      }));
    
    // Prepare data for day of week analysis
    const weekDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayData = safePostsArray.reduce((acc, post) => {
      if (!post.postedAt?.date) return acc;
      const day = new Date(post.postedAt.date).getDay();
      const engagement = (post.stats?.totalReactions || 0) + (post.stats?.comments || 0) + (post.stats?.reposts || 0);
      
      if (!acc[day]) {
        acc[day] = { count: 0, engagement: 0 };
      }
      
      acc[day].count += 1;
      acc[day].engagement += engagement;
      
      return acc;
    }, {});
    
    const dayOfWeekData = Object.entries(dayData).map(([day, data]) => ({
      name: weekDayNames[day],
      posts: data.count,
      avgEngagement: data.count > 0 ? Math.round(data.engagement / data.count) : 0
    }));
    
    // Colors for the pie chart
    const COLORS = ['#4890fe', '#38A169', '#ED8936', '#D53F8C', '#3182CE', '#48BB78', '#9F7AEA'];
    
    // Extract hashtags from posts
    const extractHashtags = (posts) => {
      if (!Array.isArray(posts) || posts.length === 0) {
        return [];
      }
      
      const hashtags = {};
      
      posts.forEach(post => {
        const matches = (post.content || '').match(/#[a-zA-Z0-9_]+/g) || [];
        
        matches.forEach(tag => {
          if (!hashtags[tag]) {
            hashtags[tag] = {
              tag,
              count: 0,
              engagement: 0,
              posts: []
            };
          }
          
          hashtags[tag].count += 1;
          hashtags[tag].engagement += (post.stats?.totalReactions || 0) + (post.stats?.comments || 0) + (post.stats?.reposts || 0);
          hashtags[tag].posts.push(post);
        });
      });
      
      // Calculate average engagement
      Object.values(hashtags).forEach(hashtag => {
        hashtag.avgEngagement = Math.round(hashtag.engagement / hashtag.count);
        // Sort posts by engagement
        hashtag.posts.sort((a, b) => {
          const engA = (a.stats?.totalReactions || 0) + (a.stats?.comments || 0) + (a.stats?.reposts || 0);
          const engB = (b.stats?.totalReactions || 0) + (b.stats?.comments || 0) + (b.stats?.reposts || 0);
          return engB - engA;
        });
      });
      
      return Object.values(hashtags).sort((a, b) => b.count - a.count);
    };
    
    // Prepare data for tag cloud
    const tagCloudData = extractHashtags(safePostsArray).map(tag => ({
      value: tag.tag,
      count: tag.count * 5 // Multiply to make the size more noticeable
    }));

    return (
      <Box sx={{ pb: 4 }}>
        {/* Analytics Dashboard Header */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#2D3748', mb: 1 }}>
            LinkedIn Analytics Dashboard
                  </Typography>
          <Typography variant="body1" color="text.secondary">
            Analyzing {safePostsArray.length} posts from your LinkedIn profile
                  </Typography>
        </Box>
        
        {/* Key Metrics Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={6} sm={3}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ 
                  width: 60, 
                  height: 60, 
                  borderRadius: '50%', 
                  bgcolor: 'rgba(72, 144, 254, 0.1)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto',
                  mb: 2
                }}>
                  <ThumbUpIcon sx={{ color: '#4890fe' }} />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                  {totalReactions.toLocaleString()}
                  </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Reactions
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

          <Grid item xs={6} sm={3}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ 
                  width: 60, 
                  height: 60, 
                  borderRadius: '50%', 
                  bgcolor: 'rgba(56, 161, 105, 0.1)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto',
                  mb: 2
                }}>
                  <CommentIcon sx={{ color: '#38A169' }} />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                  {totalComments.toLocaleString()}
                  </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Comments
                  </Typography>
                </CardContent>
              </Card>
        </Grid>

          <Grid item xs={6} sm={3}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ 
                  width: 60, 
                  height: 60, 
                  borderRadius: '50%', 
                  bgcolor: 'rgba(237, 137, 54, 0.1)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto',
                  mb: 2
                }}>
                  <ShareIcon sx={{ color: '#ED8936' }} />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                  {totalReposts.toLocaleString()}
              </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Reposts
              </Typography>
            </CardContent>
          </Card>
        </Grid>

          <Grid item xs={6} sm={3}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Box sx={{ 
                  width: 60, 
                  height: 60, 
                  borderRadius: '50%', 
                  bgcolor: 'rgba(246, 173, 85, 0.1)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto',
                  mb: 2
                }}>
                  <ThumbUpIcon sx={{ color: '#F6AD55' }} />
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                  {totalEngagement.toLocaleString()}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                Total Engagement
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        </Grid>

        {/* Post Formats and Main Themes */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Post formats
              </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Distribution
                  </Typography>
                </Box>
                <Box sx={{ height: 300 }}>
                  <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                        data={postFormatData}
                    cx="50%"
                    cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        paddingAngle={5}
                        dataKey="value"
                        label={({ name, value }) => `${name} ${value}%`}
                      >
                        {postFormatData.map((entry, index) => (
                          <Cell 
                            key={`cell-${index}`} 
                            fill={COLORS[index % COLORS.length]} 
                            stroke="none"
                          />
                    ))}
                  </Pie>
                      <RechartsTooltip formatter={(value) => `${value}%`} />
                </PieChart>
              </ResponsiveContainer>
                </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Main themes
              </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Distribution
                  </Typography>
                </Box>
                <Box sx={{ height: 300 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      layout="vertical"
                      data={(() => {
                        // Extract common themes from posts
                        const themes = {
                          'Marketing': 0,
                          'Technology': 0,
                          'Design': 0,
                          'Leadership': 0,
                          'Career': 0,
                          'Business': 0,
                          'Personal Development': 0,
                          'LinkedIn': 0
                        };
                        
                        // Define keywords for each theme
                        const themeKeywords = {
                          'Marketing': ['marketing', 'brand', 'content', 'social', 'media', 'digital', 'seo', 'audience'],
                          'Technology': ['tech', 'technology', 'innovation', 'digital', 'software', 'data', 'ai', 'automation'],
                          'Design': ['design', 'graphic', 'ui', 'ux', 'visual', 'creative', 'typography'],
                          'Leadership': ['leadership', 'management', 'team', 'leading', 'strategy', 'vision', 'executive'],
                          'Career': ['career', 'job', 'professional', 'skills', 'resume', 'interview', 'hiring'],
                          'Business': ['business', 'entrepreneur', 'startup', 'company', 'industry', 'market', 'growth'],
                          'Personal Development': ['growth', 'learning', 'mindset', 'goals', 'success', 'motivation'],
                          'LinkedIn': ['linkedin', 'network', 'profile', 'connection', 'post', 'engagement']
                        };
                        
                        // Count theme occurrences in posts
                        safePostsArray.forEach(post => {
                          if (!post.content) return;
                          
                          const content = post.content.toLowerCase();
                          Object.entries(themeKeywords).forEach(([theme, keywords]) => {
                            if (keywords.some(keyword => content.includes(keyword))) {
                              themes[theme] += 1;
                            }
                          });
                        });
                        
                        // Convert to percentage and format for chart
                        return Object.entries(themes)
                          .filter(([_, count]) => count > 0)
                          .map(([theme, count]) => ({
                            name: theme,
                            value: Math.round((count / safePostsArray.length) * 100)
                          }))
                          .sort((a, b) => b.value - a.value)
                          .slice(0, 5); // Take top 5 themes
                      })()}
                      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                      <XAxis type="number" domain={[0, 100]} tickFormatter={(value) => `${value}%`} />
                      <YAxis dataKey="name" type="category" width={150} />
                      <RechartsTooltip formatter={(value) => `${value}%`} />
                      <Bar 
                    dataKey="value" 
                        radius={[0, 4, 4, 0]}
                        fill="#4890fe"
                      />
                </BarChart>
              </ResponsiveContainer>
                </Box>
            </CardContent>
          </Card>
          </Grid>
        </Grid>

        {/* Posting Times and Content Type */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Posting times
              </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Distribution
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    This heatmap shows when you post most frequently. Darker cells indicate more posts during that day and time.
                  </Typography>
                </Box>
                <Box sx={{ height: 300, width: '100%', overflow: 'hidden' }}>
                  <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
              <Box sx={{ 
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      width: '100%',
                      height: '100%',
                display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Legend */}
                      <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end', 
                        alignItems: 'center',
                        mb: 2,
                        gap: 1
                      }}>
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: 0.5
                        }}>
                          <Box sx={{ 
                            width: 12, 
                            height: 12, 
                            bgcolor: 'rgba(72, 144, 254, 0.1)',
                            borderRadius: '2px'
                          }} />
                          <Typography variant="caption" color="text.secondary">Fewer</Typography>
                        </Box>
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: 0.5
                        }}>
                          <Box sx={{ 
                            width: 12, 
                            height: 12, 
                            bgcolor: 'rgba(72, 144, 254, 0.5)',
                            borderRadius: '2px'
                          }} />
                          <Typography variant="caption" color="text.secondary">More</Typography>
                        </Box>
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: 0.5
                        }}>
                          <Box sx={{ 
                            width: 12, 
                            height: 12, 
                            bgcolor: 'rgba(72, 144, 254, 1)',
                            borderRadius: '2px'
                          }} />
                          <Typography variant="caption" color="text.secondary">Most</Typography>
                        </Box>
                      </Box>
                      
                      {/* Heatmap */}
                      <Box sx={{ 
                        flex: 1,
                        display: 'grid',
                        gridTemplateColumns: 'auto repeat(7, 1fr)',
                        gridTemplateRows: 'auto repeat(8, 1fr)',
                        gap: 1,
                        overflow: 'auto'
                      }}>
                        {/* Header row with days */}
                        <Box sx={{ gridColumn: '1/1', gridRow: '1/1' }}></Box>
                        {weekDayNames.map((day, i) => (
                          <Box 
                            key={day} 
                            sx={{ 
                              gridColumn: `${i+2}/${i+3}`, 
                              gridRow: '1/1',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: '0.75rem',
                              color: '#4A5568'
                            }}
                          >
                            {day.substring(0, 3)}
                          </Box>
                        ))}
                        
                        {/* Time labels and heatmap cells */}
                        {hourLabels.map((hour, i) => (
                          <React.Fragment key={hour}>
                            <Box 
                              sx={{ 
                                gridColumn: '1/1', 
                                gridRow: `${i+2}/${i+3}`,
                                fontSize: '0.75rem',
                                color: '#718096',
                                pr: 1,
                                textAlign: 'right',
                                alignSelf: 'center'
                              }}
                            >
                              {hour}
                            </Box>
                            {weekDayNames.map((day, j) => {
                              const value = postingTimesHeatmap[j][i];
                              const intensity = Math.min(1, value / Math.max(1, Math.max(...postingTimesHeatmap.flat())));
                              return (
                                <Box 
                                  key={`${day}-${hour}`}
                                  sx={{ 
                                    gridColumn: `${j+2}/${j+3}`, 
                                    gridRow: `${i+2}/${i+3}`,
                                    bgcolor: `rgba(72, 144, 254, ${intensity})`,
                                    borderRadius: 1,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: intensity > 0.5 ? 'white' : '#4A5568',
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    position: 'relative',
                                    '&:hover': {
                                      boxShadow: '0 0 0 2px #4890fe',
                                      zIndex: 1
                                    },
                                    '&:hover::after': {
                                      content: `"${value} post${value !== 1 ? 's' : ''}"`,
                                      position: 'absolute',
                                      bottom: '-20px',
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                      color: 'white',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '10px',
                                      whiteSpace: 'nowrap',
                                      zIndex: 10
                                    }
                                  }}
                                >
                                  {value > 0 ? value : ''}
                                </Box>
                              );
                            })}
                          </React.Fragment>
                        ))}
                      </Box>
                    </Box>
                  </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

          {/* Content Type and Publication Days */}
          <Grid container spacing={3} sx={{ mt: 0 }}>
        <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%', 
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                border: '1px solid rgba(0, 0, 0, 0.05)'
              }}>
            <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                      Content type
              </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Distribution
                    </Typography>
                  </Box>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={contentTypeData}>
                        <PolarGrid />
                        <PolarAngleAxis dataKey="subject" />
                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                        <Radar name="Content Type" dataKey="A" stroke="#4890fe" fill="#4890fe" fillOpacity={0.6} />
                        <RechartsTooltip formatter={(value) => `${value}%`} />
                      </RadarChart>
                    </ResponsiveContainer>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%', 
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                border: '1px solid rgba(0, 0, 0, 0.05)'
              }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                      Publication days
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Distribution
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      This chart shows your posting frequency and engagement by day of the week.
                    </Typography>
                  </Box>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={weekDayNames.map((day, index) => {
                          // Get posts for this day
                          const dayPosts = safePostsArray.filter(post => {
                            if (!post.postedAt?.date) return false;
                            return new Date(post.postedAt.date).getDay() === (index === 6 ? 0 : index + 1);
                          });
                          
                          // Calculate total likes for this day
                          const totalLikes = dayPosts.reduce((sum, post) => sum + (post.stats?.totalReactions || 0), 0);
                          
                          // Calculate average likes per post for this day
                          const avgLikes = dayPosts.length ? Math.round(totalLikes / dayPosts.length) : 0;
                          
                          return {
                            name: day.substring(0, 3),
                            posts: dayPosts.length,
                            likes: totalLikes,
                            avgLikes: avgLikes
                          };
                        })}
                        margin={{ top: 10, right: 30, left: 10, bottom: 20 }}
                      >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                          dataKey="name" 
                          tick={{ fill: '#4A5568', fontSize: 12 }}
                          axisLine={{ stroke: '#E2E8F0' }}
                          tickLine={{ stroke: '#E2E8F0' }}
                        />
                        <YAxis 
                          yAxisId="left" 
                          orientation="left"
                          tick={{ fill: '#4A5568', fontSize: 12 }}
                          axisLine={{ stroke: '#E2E8F0' }}
                          tickLine={{ stroke: '#E2E8F0' }}
                    label={{ 
                            value: 'Posts', 
                            angle: -90, 
                            position: 'insideLeft',
                            fill: '#4A5568',
                            fontSize: 12,
                            dx: -10
                    }}
                  />
                  <YAxis 
                          yAxisId="right" 
                          orientation="right"
                          tick={{ fill: '#4A5568', fontSize: 12 }}
                          axisLine={{ stroke: '#E2E8F0' }}
                          tickLine={{ stroke: '#E2E8F0' }}
                    label={{ 
                            value: 'Likes', 
                            angle: 90, 
                            position: 'insideRight',
                            fill: '#4A5568',
                            fontSize: 12,
                            dx: 10
                    }}
                  />
                  <RechartsTooltip 
                          formatter={(value, name) => {
                            switch(name) {
                              case 'posts': return [`${value} posts`, 'Posts'];
                              case 'likes': return [`${value} likes`, 'Total Likes'];
                              case 'avgLikes': return [`${value} likes/post`, 'Avg. Likes/Post'];
                              default: return [value, name];
                            }
                          }}
                          contentStyle={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            border: '1px solid rgba(0, 0, 0, 0.05)',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
                          }}
                        />
                        <Legend 
                          wrapperStyle={{ paddingTop: 10 }}
                          iconType="circle"
                        />
                        <Bar 
                          yAxisId="left" 
                          dataKey="posts" 
                          name="Posts" 
                          fill="#4890fe" 
                          radius={[4, 4, 0, 0]}
                          barSize={20}
                        />
                        <Bar 
                          yAxisId="right" 
                          dataKey="likes" 
                          name="Total Likes" 
                          fill="#38A169" 
                          radius={[4, 4, 0, 0]}
                          barSize={20}
                        />
                        <Bar 
                          yAxisId="right" 
                          dataKey="avgLikes" 
                          name="Avg. Likes/Post" 
                          fill="#ED8936" 
                          radius={[4, 4, 0, 0]}
                          barSize={20}
                        />
                      </BarChart>
              </ResponsiveContainer>
                  </Box>
            </CardContent>
          </Card>
            </Grid>
          </Grid>
        </Grid>

        {/* Engagement Distribution and Post Type Distribution */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* ... existing charts ... */}
        </Grid>
        
        {/* Engagement Over Time */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* ... existing charts ... */}
        </Grid>
        
        {/* Day of Week Analysis and Posting Insights */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* ... existing charts ... */}
        </Grid>
        
        {/* Hashtag Cloud and Top Hashtags */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* ... existing charts ... */}
        </Grid>
        
        {/* Hooks from Best Posts */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12}>
            <Card sx={{ 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Hooks from best posts
              </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Number of likes
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    The first sentence of your most engaging posts - these opening hooks captured your audience's attention.
                  </Typography>
                </Box>
                <TableContainer component={Paper} sx={{ 
                  boxShadow: 'none', 
                  border: '1px solid rgba(0, 0, 0, 0.05)',
                  borderRadius: 2,
                  maxHeight: 400,
                  overflow: 'auto'
                }}>
                  <Table>
                  <TableBody>
                      {safePostsArray
                        .sort((a, b) => (b.stats?.totalReactions || 0) - (a.stats?.totalReactions || 0))
                        .slice(0, 10)
                        .map((post, index) => {
                          // Extract first sentence (ending with ., !, or ?)
                          const firstSentence = post.content?.split(/[.!?]/)[0]?.trim() || '';
                          // Limit to 100 characters
                          const hook = firstSentence.length > 100 
                            ? firstSentence.substring(0, 97) + '...' 
                            : firstSentence;
                           
                          return (
                        <TableRow 
                              key={index}
                          hover
                              onClick={() => setSelectedPost(post)}
                          sx={{ cursor: 'pointer' }}
                        >
                              <TableCell width={40}>
                                <Box sx={{ 
                                  width: 30, 
                                  height: 30, 
                                  borderRadius: '50%', 
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  bgcolor: index < 3 
                                    ? ['rgba(237, 137, 54, 0.1)', 'rgba(72, 144, 254, 0.1)', 'rgba(56, 161, 105, 0.1)'][index]
                                    : 'rgba(160, 174, 192, 0.1)',
                                  color: index < 3 
                                    ? ['#ED8936', '#4890fe', '#38A169'][index]
                                    : '#718096',
                                  fontWeight: 600
                                }}>
                                  {index + 1}
                                </Box>
                          </TableCell>
                          <TableCell>
                            <Typography 
                                  variant="body2" 
                              sx={{ 
                                    fontWeight: index < 3 ? 600 : 400,
                                    color: '#2D3748'
                                  }}
                                >
                                  {hook}
                            </Typography>
                          </TableCell>
                              <TableCell align="right" width={100}>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    fontWeight: 600,
                                    color: '#4890fe'
                                  }}
                                >
                                  {post.stats?.totalReactions || 0}
                                </Typography>
                          </TableCell>
                        </TableRow>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          </Grid>
        </Grid>

        {/* Content Length Analysis */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12}>
            <Card sx={{ 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Content length analysis
              </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Engagement by post length
                  </Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    This chart shows how the length of your posts correlates with engagement.
                  </Typography>
                </Box>
                <Box sx={{ height: 400 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <ScatterChart
                      margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis 
                        type="number" 
                        dataKey="length" 
                        name="Length" 
                        unit=" chars"
                        label={{ 
                          value: 'Post Length (characters)', 
                          position: 'insideBottom',
                          offset: -10,
                          fill: '#4A5568',
                          fontSize: 12
                        }}
                        tick={{ fill: '#4A5568', fontSize: 12 }}
                        axisLine={{ stroke: '#E2E8F0' }}
                        tickLine={{ stroke: '#E2E8F0' }}
                      />
                      <YAxis 
                        type="number" 
                        dataKey="engagement" 
                        name="Engagement"
                        label={{ 
                          value: 'Total Engagement', 
                          angle: -90, 
                          position: 'insideLeft',
                          fill: '#4A5568',
                          fontSize: 12
                        }}
                        tick={{ fill: '#4A5568', fontSize: 12 }}
                        axisLine={{ stroke: '#E2E8F0' }}
                        tickLine={{ stroke: '#E2E8F0' }}
                      />
                      <RechartsTooltip 
                        cursor={{ strokeDasharray: '3 3' }}
                        formatter={(value, name) => {
                          if (name === 'Length') return [`${value} characters`, name];
                          if (name === 'Engagement') return [value, 'Total Engagement'];
                          return [value, name];
                        }}
                        contentStyle={{
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          border: '1px solid rgba(0, 0, 0, 0.05)',
                          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)'
                        }}
                        labelFormatter={(_, data) => {
                          const post = data[0]?.payload?.post;
                          if (!post) return 'Post';
                          return post.content?.substring(0, 50) + '...';
                        }}
                      />
                      <Scatter 
                        name="Posts" 
                        data={safePostsArray.map(post => {
                          const length = post.content?.length || 0;
                          const engagement = (post.stats?.totalReactions || 0) + 
                                            (post.stats?.comments || 0) + 
                                            (post.stats?.reposts || 0);
                          return {
                            length,
                            engagement,
                            post // Include the post for tooltip reference
                          };
                        })} 
                        fill="#4890fe"
                      />
                      {/* Add a trend line */}
                      <Line 
                        type="monotone" 
                        dataKey="trend" 
                        stroke="#ED8936" 
                        strokeWidth={2}
                        dot={false}
                        activeDot={false}
                        data={(() => {
                          // Calculate trend line
                          const data = safePostsArray.map(post => ({
                            x: post.content?.length || 0,
                            y: (post.stats?.totalReactions || 0) + 
                               (post.stats?.comments || 0) + 
                               (post.stats?.reposts || 0)
                          }));
                          
                          // Simple linear regression
                          const n = data.length;
                          if (n < 2) return [];
                          
                          const sumX = data.reduce((sum, point) => sum + point.x, 0);
                          const sumY = data.reduce((sum, point) => sum + point.y, 0);
                          const sumXY = data.reduce((sum, point) => sum + point.x * point.y, 0);
                          const sumXX = data.reduce((sum, point) => sum + point.x * point.x, 0);
                          
                          const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX) || 0;
                          const intercept = (sumY - slope * sumX) / n || 0;
                          
                          // Get min and max x values
                          const minX = Math.min(...data.map(point => point.x));
                          const maxX = Math.max(...data.map(point => point.x));
                          
                          // Create trend line points
                          return [
                            { length: minX, trend: intercept + slope * minX },
                            { length: maxX, trend: intercept + slope * maxX }
                          ];
                        })()}
                      />
                    </ScatterChart>
                  </ResponsiveContainer>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    {(() => {
                      // Calculate average post length and engagement
                      const avgLength = safePostsArray.reduce((sum, post) => sum + (post.content?.length || 0), 0) / 
                                       (safePostsArray.length || 1);
                      
                      // Find optimal length range
                      const lengthRanges = [
                        { min: 0, max: 100, sum: 0, count: 0 },
                        { min: 100, max: 250, sum: 0, count: 0 },
                        { min: 250, max: 500, sum: 0, count: 0 },
                        { min: 500, max: 1000, sum: 0, count: 0 },
                        { min: 1000, max: 2000, sum: 0, count: 0 },
                        { min: 2000, max: Infinity, sum: 0, count: 0 }
                      ];
                      
                      safePostsArray.forEach(post => {
                        const length = post.content?.length || 0;
                        const engagement = (post.stats?.totalReactions || 0) + 
                                          (post.stats?.comments || 0) + 
                                          (post.stats?.reposts || 0);
                        
                        const range = lengthRanges.find(r => length >= r.min && length < r.max);
                        if (range) {
                          range.sum += engagement;
                          range.count++;
                        }
                      });
                      
                      // Calculate average engagement for each range
                      lengthRanges.forEach(range => {
                        range.avg = range.count > 0 ? range.sum / range.count : 0;
                      });
                      
                      // Find the range with highest average engagement
                      const bestRange = [...lengthRanges].sort((a, b) => b.avg - a.avg)[0];
                      
                      if (bestRange.count === 0) {
                        return 'Not enough data to determine optimal post length.';
                      }
                      
                      return `Your posts between ${bestRange.min}-${bestRange.max === Infinity ? '∞' : bestRange.max} characters receive the most engagement.`;
                    })()}
                          </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // Add a FilterBar component
  const FilterBar = () => (
    <Box sx={{ 
      mb: 3, 
      display: 'flex', 
      flexDirection: { xs: 'column', md: 'row' }, 
      alignItems: { xs: 'stretch', md: 'center' },
      gap: 2,
      p: 2,
      bgcolor: '#ffffff',
      borderRadius: 2,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      border: '1px solid rgba(0, 0, 0, 0.05)'
    }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Content Type</InputLabel>
        <Select
          value={filters.format}
          onChange={(e) => setFilters(prev => ({ ...prev, format: e.target.value }))}
          label="Content Type"
                              sx={{
            borderRadius: '8px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.1)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#4890fe',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(72, 144, 254, 0.5)',
            }
          }}
        >
          <MenuItem value="all">All Types</MenuItem>
          <MenuItem value="Image">Images</MenuItem>
          <MenuItem value="Video">Videos</MenuItem>
          <MenuItem value="Carousel">Carousels & Documents</MenuItem>
          <MenuItem value="Text">Text Only</MenuItem>
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Search"
        value={filters.search}
        onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&.Mui-focused fieldset': {
              borderColor: '#4890fe',
            },
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.1)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(72, 144, 254, 0.5)',
            }
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          )
        }}
      />
    </Box>
  );

  // Add a RecommendationsTab component
  const RecommendationsTab = ({ posts }) => {
    // Ensure posts is an array
    const safePostsArray = Array.isArray(posts) ? posts : [];
    
    // Calculate best time to post
    const calculateBestTimeToPost = () => {
      if (safePostsArray.length === 0) return { day: 'Monday', hour: 9 };
      
      // Create a 2D array for day/hour combinations
      const dayHourEngagement = Array(7).fill().map(() => Array(24).fill(0));
      const dayHourCount = Array(7).fill().map(() => Array(24).fill(0));
      
      // Fill the arrays with engagement data
      safePostsArray.forEach(post => {
        if (!post.postedAt?.date) return;
        
        const date = new Date(post.postedAt.date);
        const day = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
        const hour = date.getHours();
        
        const engagement = (post.stats?.totalReactions || 0) + 
                          (post.stats?.comments || 0) + 
                          (post.stats?.reposts || 0);
        
        dayHourEngagement[day][hour] += engagement;
        dayHourCount[day][hour] += 1;
      });
      
      // Calculate average engagement for each day/hour
      const avgEngagement = Array(7).fill().map(() => Array(24).fill(0));
      
      for (let day = 0; day < 7; day++) {
        for (let hour = 0; hour < 24; hour++) {
          if (dayHourCount[day][hour] > 0) {
            avgEngagement[day][hour] = dayHourEngagement[day][hour] / dayHourCount[day][hour];
          }
        }
      }
      
      // Find the day/hour with highest average engagement
      let bestDay = 1; // Default to Monday
      let bestHour = 9; // Default to 9 AM
      let maxEngagement = 0;
      
      for (let day = 0; day < 7; day++) {
        for (let hour = 0; hour < 24; hour++) {
          if (avgEngagement[day][hour] > maxEngagement) {
            maxEngagement = avgEngagement[day][hour];
            bestDay = day;
            bestHour = hour;
          }
        }
      }
      
      // Convert day number to name
      const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      
      return { day: dayNames[bestDay], hour: bestHour };
    };
    
    // Calculate best content type
    const calculateBestContentType = () => {
      if (safePostsArray.length === 0) return 'Image';
      
      const typeEngagement = {
        'Image': { total: 0, count: 0 },
        'Video': { total: 0, count: 0 },
        'Carousel': { total: 0, count: 0 },
        'Text': { total: 0, count: 0 }
      };
      
      safePostsArray.forEach(post => {
        const type = determinePostFormat(post);
        const engagement = (post.stats?.totalReactions || 0) + 
                          (post.stats?.comments || 0) + 
                          (post.stats?.reposts || 0);
        
        if (typeEngagement[type]) {
          typeEngagement[type].total += engagement;
          typeEngagement[type].count += 1;
        }
      });
      
      // Calculate average engagement for each type
      let bestType = 'Image';
      let maxAvgEngagement = 0;
      
      Object.entries(typeEngagement).forEach(([type, data]) => {
        if (data.count > 0) {
          const avgEngagement = data.total / data.count;
          if (avgEngagement > maxAvgEngagement) {
            maxAvgEngagement = avgEngagement;
            bestType = type;
          }
        }
      });
      
      return bestType;
    };
    
    // Calculate optimal post length
    const calculateOptimalLength = () => {
      if (safePostsArray.length === 0) return { min: 250, max: 500 };
      
      // Define length ranges
      const lengthRanges = [
        { min: 0, max: 100, sum: 0, count: 0 },
        { min: 100, max: 250, sum: 0, count: 0 },
        { min: 250, max: 500, sum: 0, count: 0 },
        { min: 500, max: 1000, sum: 0, count: 0 },
        { min: 1000, max: 2000, sum: 0, count: 0 },
        { min: 2000, max: Infinity, sum: 0, count: 0 }
      ];
      
      safePostsArray.forEach(post => {
        const length = post.content?.length || 0;
        const engagement = (post.stats?.totalReactions || 0) + 
                          (post.stats?.comments || 0) + 
                          (post.stats?.reposts || 0);
        
        const range = lengthRanges.find(r => length >= r.min && length < r.max);
        if (range) {
          range.sum += engagement;
          range.count++;
        }
      });
      
      // Calculate average engagement for each range
      lengthRanges.forEach(range => {
        range.avg = range.count > 0 ? range.sum / range.count : 0;
      });
      
      // Find the range with highest average engagement
      const bestRange = [...lengthRanges].sort((a, b) => b.avg - a.avg)[0];
      
      return { min: bestRange.min, max: bestRange.max };
    };
    
    // Calculate best hashtags
    const calculateBestHashtags = () => {
      if (safePostsArray.length === 0) return [];
      
      const hashtags = {};
      
      safePostsArray.forEach(post => {
        const matches = (post.content || '').match(/#[a-zA-Z0-9_]+/g) || [];
        const engagement = (post.stats?.totalReactions || 0) + 
                          (post.stats?.comments || 0) + 
                          (post.stats?.reposts || 0);
        
        matches.forEach(tag => {
          if (!hashtags[tag]) {
            hashtags[tag] = { count: 0, engagement: 0 };
          }
          
          hashtags[tag].count += 1;
          hashtags[tag].engagement += engagement;
        });
      });
      
      // Calculate average engagement for each hashtag
      Object.keys(hashtags).forEach(tag => {
        hashtags[tag].avgEngagement = hashtags[tag].engagement / hashtags[tag].count;
      });
      
      // Sort by average engagement and return top 5
      return Object.entries(hashtags)
        .sort((a, b) => b[1].avgEngagement - a[1].avgEngagement)
        .slice(0, 5)
        .map(([tag]) => tag);
    };
    
    // Calculate best opening hooks
    const calculateBestHooks = () => {
      if (safePostsArray.length === 0) return [];
      
      // Get top 3 posts by engagement
      const topPosts = [...safePostsArray]
        .sort((a, b) => {
          const engA = (a.stats?.totalReactions || 0) + (a.stats?.comments || 0) + (a.stats?.reposts || 0);
          const engB = (b.stats?.totalReactions || 0) + (b.stats?.comments || 0) + (b.stats?.reposts || 0);
          return engB - engA;
        })
        .slice(0, 3);
      
      // Extract first sentence from each post
      return topPosts.map(post => {
        const firstSentence = post.content?.split(/[.!?]/)[0]?.trim() || '';
        return firstSentence.length > 100 ? firstSentence.substring(0, 97) + '...' : firstSentence;
      });
    };
    
    // Get the recommendations
    const bestTime = calculateBestTimeToPost();
    const bestContentType = calculateBestContentType();
    const optimalLength = calculateOptimalLength();
    const bestHashtags = calculateBestHashtags();
    const bestHooks = calculateBestHooks();
    
    // Format the best hour for display
    const formatHour = (hour) => {
      if (hour === 0) return '12 AM';
      if (hour === 12) return '12 PM';
      return hour < 12 ? `${hour} AM` : `${hour - 12} PM`;
    };
    
    return (
      <Box sx={{ pb: 4 }}>
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#2D3748', mb: 1 }}>
            LinkedIn Posting Recommendations
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Based on the analysis of your {safePostsArray.length} posts
          </Typography>
        </Box>
        
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Best Time to Post */}
          <Grid item xs={12} md={4}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Best Time to Post
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Posts at this time receive the most engagement
                  </Typography>
                </Box>
                
                <Box sx={{ 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  p: 3
                }}>
                  <Box sx={{ 
                    width: 80, 
                    height: 80, 
                    borderRadius: '50%', 
                    bgcolor: 'rgba(72, 144, 254, 0.1)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    <AccessTimeIcon sx={{ fontSize: 40, color: '#4890fe' }} />
                  </Box>
                  
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                    {bestTime.day} at {formatHour(bestTime.hour)}
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                    Schedule your posts for this time to maximize engagement
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          
          {/* Best Content Type */}
          <Grid item xs={12} md={4}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Best Content Type
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This format receives the most engagement
                  </Typography>
                </Box>
                
                <Box sx={{ 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  p: 3
                }}>
                  <Box sx={{ 
                    width: 80, 
                    height: 80, 
                    borderRadius: '50%', 
                    bgcolor: 'rgba(72, 144, 254, 0.1)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    {bestContentType === 'Image' && <ImageIcon sx={{ fontSize: 40, color: '#4890fe' }} />}
                    {bestContentType === 'Video' && <VideocamIcon sx={{ fontSize: 40, color: '#4890fe' }} />}
                    {bestContentType === 'Carousel' && <ViewCarouselIcon sx={{ fontSize: 40, color: '#4890fe' }} />}
                    {bestContentType === 'Text' && <TextFieldsIcon sx={{ fontSize: 40, color: '#4890fe' }} />}
                  </Box>
                  
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                    {bestContentType}
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {bestContentType === 'Image' && 'Posts with images receive more engagement than other formats'}
                    {bestContentType === 'Video' && 'Video content drives higher engagement on your profile'}
                    {bestContentType === 'Carousel' && 'Multi-slide content performs best with your audience'}
                    {bestContentType === 'Text' && 'Your audience engages most with text-only posts'}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          
          {/* Optimal Post Length */}
          <Grid item xs={12} md={4}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Optimal Post Length
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This character range gets the most engagement
                  </Typography>
                </Box>
                
                <Box sx={{ 
                  flex: 1, 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  p: 3
                }}>
                  <Box sx={{ 
                    width: 80, 
                    height: 80, 
                    borderRadius: '50%', 
                    bgcolor: 'rgba(72, 144, 254, 0.1)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    <TextSnippetIcon sx={{ fontSize: 40, color: '#4890fe' }} />
                  </Box>
                  
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#2D3748', mb: 1 }}>
                    {optimalLength.min}-{optimalLength.max === Infinity ? '∞' : optimalLength.max} characters
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {optimalLength.min < 250 ? 'Shorter posts perform better with your audience' : 
                     optimalLength.max > 1000 ? 'Your audience engages more with longer, detailed posts' :
                     'Medium-length posts get the best engagement from your audience'}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Best Hashtags */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Top Performing Hashtags
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    These hashtags drive the most engagement
                  </Typography>
                </Box>
                
                {bestHashtags.length > 0 ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {bestHashtags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag}
                        sx={{
                          bgcolor: 'rgba(72, 144, 254, 0.1)',
                          color: '#4890fe',
                          fontWeight: 600,
                          fontSize: '0.9rem',
                          py: 2
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No hashtags found in your posts. Try adding relevant hashtags to increase visibility.
                            </Typography>
                          )}
              </CardContent>
            </Card>
          </Grid>
          
          {/* Effective Opening Hooks */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              height: '100%', 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Effective Opening Hooks
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    First sentences from your most engaging posts
                  </Typography>
                </Box>
                
                {bestHooks.length > 0 ? (
                  <List>
                    {bestHooks.map((hook, index) => (
                      <ListItem key={index} sx={{ px: 0 }}>
                        <ListItemIcon>
                          <Box sx={{ 
                            width: 28, 
                            height: 28, 
                            borderRadius: '50%', 
                            bgcolor: ['rgba(237, 137, 54, 0.1)', 'rgba(72, 144, 254, 0.1)', 'rgba(56, 161, 105, 0.1)'][index],
                            color: ['#ED8936', '#4890fe', '#38A169'][index],
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 600
                          }}>
                            {index + 1}
                          </Box>
                        </ListItemIcon>
                        <ListItemText 
                          primary={hook}
                          primaryTypographyProps={{
                            variant: 'body2',
                            color: '#2D3748',
                            fontWeight: 500
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    Not enough data to determine effective opening hooks.
                  </Typography>
                )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
        
        {/* Content Strategy Tips */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ 
              borderRadius: 2,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <CardContent>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#2D3748' }}>
                    Content Strategy Tips
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Actionable recommendations to improve your LinkedIn engagement
                  </Typography>
                </Box>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ p: 2, bgcolor: 'rgba(72, 144, 254, 0.05)', borderRadius: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <CalendarTodayIcon sx={{ color: '#4890fe', mr: 1 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#2D3748' }}>
                          Posting Schedule
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Post consistently on {bestTime.day}s around {formatHour(bestTime.hour)}. Aim for 2-3 posts per week to maintain visibility without overwhelming your audience.
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={12} md={4}>
                    <Box sx={{ p: 2, bgcolor: 'rgba(56, 161, 105, 0.05)', borderRadius: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <FormatQuoteIcon sx={{ color: '#38A169', mr: 1 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#2D3748' }}>
                          Content Format
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Focus on creating {bestContentType.toLowerCase()} posts with {optimalLength.min < 250 ? 'concise' : optimalLength.max > 1000 ? 'detailed' : 'medium-length'} content. Use relevant hashtags like {bestHashtags.length > 0 ? bestHashtags.slice(0, 2).join(' and ') : 'industry-specific terms'} to increase visibility.
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={12} md={4}>
                    <Box sx={{ p: 2, bgcolor: 'rgba(237, 137, 54, 0.05)', borderRadius: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PeopleIcon sx={{ color: '#ED8936', mr: 1 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#2D3748' }}>
                          Engagement Tactics
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        Start posts with attention-grabbing hooks. Respond to comments promptly to boost algorithm visibility. Ask questions to encourage audience participation.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // Add this function to handle opening a post
  const handleOpenPost = (post) => {
    setSelectedPost(post);
  };

  // Add this near the top with other handlers
  const handleViewTypeChange = (event, newViewType) => {
    if (newViewType !== null) {
      setViewType(newViewType);
    }
  };

  // Add this before the return statement
  const renderGridView = () => {
    const filteredPosts = getFilteredAndSortedPosts(posts);
    
    return (
      <Masonry
        breakpointCols={{
          default: 4,
          1200: 3,
          900: 2,
          600: 1
        }}
        className="masonry-grid"
        columnClassName="masonry-grid_column"
      >
        {filteredPosts.map((post) => (
          <div key={post.id || post.urn || `post-${Math.random()}`} style={{ marginBottom: '16px' }}>
            <PostCard
              post={post}
              onCommentClick={() => handleOpenCommentDialog(post)}
              onRemixClick={() => handleRemixClick(post)}
            />
          </div>
        ))}
      </Masonry>
    );
  };

  // Function to fetch the latest update time
  const fetchLatestUpdateTime = async (username) => {
    try {
      const response = await api.get('/api/linkedin/latest-update', {
        params: { username }
      });
      if (response.data && response.data.lastUpdate) {
        const date = new Date(response.data.lastUpdate);
        if (!isNaN(date.getTime())) {
          setLastUpdateTime(date);
        }
      }
    } catch (error) {
      console.error('Error fetching latest update time:', error);
    }
  };

  // Update useEffect to fetch latest update time
  useEffect(() => {
    if (linkedinProfile) {
      const username = extractUsername(linkedinProfile);
      if (username) {
        fetchLatestUpdateTime(username);
        
        // Set up interval to check for updates every minute
        const interval = setInterval(() => {
          fetchLatestUpdateTime(username);
        }, 60000); // Check every minute
        
        return () => clearInterval(interval);
      }
    }
  }, [linkedinProfile]);

  // Conditional rendering based on subscription status FIRST
  if (subscriptionStatusLoading) {
    return <LoadingScreen message="Loading LinkedIn Metrics..." />;
  }

  // Then, handle initial loading of profile data if feature IS allowed
  if (initialLoading) {
    return <LoadingScreen message="Loading LinkedIn Metrics..." />;
  }

  return (
    <>
      <Helmet>
        <title>LinkedIn Analytics | Instation</title>
        <meta name="description" content="Track and analyze your LinkedIn post performance with detailed metrics and insights." />
      </Helmet>
      
      <Container maxWidth="xl" className="page-container" sx={{ overflow: 'visible' }}>
        <Box className="content-container" sx={{ overflow: 'visible', height: 'auto' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} className="content-panel" sx={{ overflow: 'visible', height: 'auto' }}>
              <Paper elevation={0} className="content-paper" sx={{ overflow: 'visible' }}>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#2D3748' }}>
                    LinkedIn Metrics
                  </Typography>

                  {!userProfile?.linkedinProfile ? (
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        py: 8,
                        textAlign: 'center',
                        border: '1px dashed rgba(0, 0, 0, 0.1)',
                        borderRadius: 2,
                        bgcolor: 'rgba(0, 0, 0, 0.01)',
                        px: 3
                      }}
                    >
                      <LinkedInIcon sx={{ fontSize: 60, color: '#0A66C2', mb: 2, opacity: 0.7 }} />
                      <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                        No LinkedIn Profile Connected
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 500 }}>
                        To analyze your LinkedIn metrics, please add your LinkedIn profile URL in your profile settings.
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/dashboard/profile')}
                        startIcon={<PersonIcon />}
                        sx={{
                          borderRadius: '8px',
                          textTransform: 'none',
                          fontWeight: 600,
                          bgcolor: '#4890fe',
                          '&:hover': {
                            bgcolor: '#3a7ad9'
                          }
                        }}
                      >
                        Go to Profile Settings
                      </Button>
                    </Box>
                  ) : (
                    <Box 
                      sx={{ 
                        mb: 3,
                        p: 2,
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#ffffff',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                          src={linkedinProfileData?.profile_picture || userProfile?.image}
                          sx={{ 
                            width: 48, 
                            height: 48, 
                            mr: 2,
                            border: '2px solid #0A66C2'
                          }}
                        >
                          {(linkedinProfileData?.name || userProfile?.name) ? (linkedinProfileData?.name || userProfile?.name).charAt(0) : <PersonIcon />}
                        </Avatar>
                        
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#2D3748' }}>
                            {linkedinProfileData?.name || userProfile?.name || 'Your Profile'}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <LinkedInIcon 
                              sx={{ 
                                color: '#0A66C2', 
                                fontSize: 16, 
                                mr: 0.5 
                              }} 
                            />
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                              {linkedinProfile}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {/* Last Updated text */}
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          color: 'text.secondary',
                          fontSize: '0.875rem'
                        }}>
                          <AccessTimeIcon fontSize="small" />
                          Last Updated: {
                            lastUpdateTime && !isNaN(lastUpdateTime.getTime()) ? 
                              lastUpdateTime.toLocaleString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                              }) 
                            : 'Checking...'
                          }
                          <Tooltip title="Data automatically refreshes every 24 hours" arrow placement="top">
                            <InfoIcon sx={{ fontSize: 16, ml: 1, cursor: 'help' }} />
                          </Tooltip>
                        </Box>

                        {/* Search and filters */}
                        {posts.length > 0 && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <TextField
                              placeholder="Search posts..."
                              size="small"
                              value={filters.search}
                              onChange={(e) => setFilters({...filters, search: e.target.value})}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchOutlined />
                                  </InputAdornment>
                                ),
                              }}
                              sx={{
                                width: 200,
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '8px',
                                  fontSize: '0.875rem'
                                }
                              }}
                            />
                            
                            <FormControl size="small" sx={{ minWidth: 120 }}>
                              <Select
                                value={filters.format}
                                onChange={(e) => setFilters({...filters, format: e.target.value})}
                                displayEmpty
                                sx={{ 
                                  borderRadius: '8px',
                                  fontSize: '0.875rem'
                                }}
                              >
                                <MenuItem value="all">All Types</MenuItem>
                                <MenuItem value="Image">Images</MenuItem>
                                <MenuItem value="Video">Videos</MenuItem>
                                <MenuItem value="Carousel">Carousels & Documents</MenuItem>
                                <MenuItem value="Text">Text Only</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  )}

                  {error && (
                    <Alert severity="error" sx={{ 
                      mb: 3,
                      borderRadius: '8px'
                    }}>
                      {error}
                    </Alert>
                  )}

                  {posts.length > 0 && (
                    <>
                      {/* Remove FilterBar from here since we moved it above */}
                      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                        <Tabs 
                          value={activeTab} 
                          onChange={(e, newValue) => setActiveTab(newValue)}
                          sx={{
                            '& .MuiTabs-indicator': {
                              backgroundColor: '#4890fe',
                            },
                            '& .MuiTab-root': {
                              textTransform: 'none',
                              fontWeight: 600,
                              color: '#718096',
                              '&.Mui-selected': {
                                color: '#4890fe',
                              },
                            },
                          }}
                        >
                          <Tab label="Posts" value="posts" />
                          <Tab label="Analytics" value="analytics" />
                          <Tab label="Recommendations" value="recommendations" />
                        </Tabs>
                      </Box>

                      {activeTab === 'posts' && (
                        <>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <Typography variant="body2" sx={{ mr: 2 }}>
                                Page {page} of {totalPages}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                  disabled={page === 1 || loading}
                                  onClick={() => handlePageChange(Math.max(1, page - 1))}
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    minWidth: 'auto',
                                    borderColor: '#e0e0e0',
                                    color: '#616161'
                                  }}
                                >
                                  Prev
                                </Button>
                                <Button
                                  disabled={page >= totalPages || loading}
                                  onClick={() => handlePageChange(Math.min(totalPages, page + 1))}
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    minWidth: 'auto',
                                    borderColor: '#e0e0e0',
                                    color: '#616161'
                                  }}
                                >
                                  Next
                                </Button>
                              </Box>
                            </Box>

                            <ToggleButtonGroup
                              value={viewType}
                              exclusive
                              onChange={handleViewTypeChange}
                              aria-label="view type"
                              size="small"
                              sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                '& .MuiToggleButton-root': {
                                  border: 'none',
                                  px: 1.5,
                                  '&.Mui-selected': {
                                    bgcolor: 'rgba(72, 144, 254, 0.08)',
                                    color: '#4890fe',
                                    '&:hover': {
                                      bgcolor: 'rgba(72, 144, 254, 0.12)'
                                    }
                                  }
                                }
                              }}
                            >
                              <ToggleButton value="table" aria-label="table view">
                                <ViewListIcon />
                              </ToggleButton>
                              <ToggleButton value="grid" aria-label="grid view">
                                <GridViewIcon />
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Box>

                          {viewType === 'table' ? (
                            <PostsTable posts={getFilteredAndSortedPosts(posts)} />
                          ) : (
                            renderGridView()
                          )}
                        </>
                      )}

                      {activeTab === 'analytics' && (
                        subscriptionStatusLoading ? (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <CircularProgress />
                            <Typography sx={{ ml: 2 }}>Loading analytics data...</Typography>
                          </Box>
                        ) : isFeatureAllowed ? (
                          // Render AnalyticsTab if feature is allowed
                          <AnalyticsTab posts={getFilteredAndSortedPosts(posts)} />
                        ) : (
                          // Render FeatureLockOverlay if feature is not allowed
                          <Box sx={{ position: 'relative', height: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FeatureLockOverlay featureName="LinkedIn Analytics" currentPlan={currentPlanId} />
                          </Box>
                        )
                      )}

                      {activeTab === 'recommendations' && (
                         subscriptionStatusLoading ? (
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                            <CircularProgress />
                            <Typography sx={{ ml: 2 }}>Loading recommendations...</Typography>
                          </Box>
                        ) : isFeatureAllowed ? (
                          // Render RecommendationsTab if feature is allowed
                          <RecommendationsTab posts={getFilteredAndSortedPosts(posts)} />
                        ) : (
                          // Render FeatureLockOverlay if feature is not allowed
                          <Box sx={{ position: 'relative', height: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FeatureLockOverlay featureName="LinkedIn Recommendations" currentPlan={currentPlanId} />
                          </Box>
                        )
                      )}
                    </>
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        
        {/* Post Modal */}
        <Dialog
          open={selectedPost !== null}
          onClose={() => setSelectedPost(null)}
          maxWidth="md"
          fullWidth
        >
          {selectedPost && (
            <PostModal post={selectedPost} onClose={() => setSelectedPost(null)} />
          )}
        </Dialog>
      </Container>
    </>
  );
};

export default LinkedInMetrics; 